"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _this = void 0;

var _default = /*#__PURE__*/_react.default.memo(function () {
  (0, _newArrowCheck2.default)(this, _this);
  return /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M9.14644661,17.2928932 L10.5606602,18.7071068 L16.5606602,12.7071068 C16.9211441,12.3466228 16.9488737,11.7793918 16.6438488,11.3871006 L16.5606602,11.2928932 L10.5606602,5.29289322 L9.14644661,6.70710678 L14.438545,12 L9.14644661,17.2928932 Z"
  });
}.bind(void 0));

exports.default = _default;